import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'

import 'lazysizes';

import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

import MainNavigation from './mainNavigation'

class OsloWorld {

	constructor() {
		
        this.siteHeader = document.querySelector('.site-header')
		this.toggleMenuButton = document.querySelector('.site-header__toggle-menu-button')
		this.prevScrollPosition = 0;

        this.scrollHandler = this.scrollHandler.bind(this);

	}

	scrollHandler(e) {

        if ( document.body.classList.contains('menu-is-open') ) {
            return
        }

        let newPosition = window.scrollY,
			offset = 50;

        if( newPosition > offset ) {
            this.siteHeader.classList.add('site-header--solid');
            if ( newPosition > this.prevScrollPosition+25 ) {
                this.siteHeader.classList.add('site-header--hidden');
            } 
            if ( newPosition < this.prevScrollPosition-25 ) {
                this.siteHeader.classList.remove('site-header--hidden');
            }
        } else {
            this.siteHeader.classList.remove('site-header--solid','site-header--hidden');
        }
        this.prevScrollPosition = newPosition;

    }


    initSwiperSlideshows() {

        const slideshows = document.querySelectorAll('.swiper-container')
        if ( slideshows ) {

            const swiper = []

            slideshows.forEach((slideshow, index) => {

                slideshow.classList.add(`swiper-${index}`)

                const prevButton = document.querySelector(`.swiper-${index} > .swiper-button-prev`)
                const nextButton = document.querySelector(`.swiper-${index} > .swiper-button-next`)

                if ( prevButton && nextButton ) {

                    prevButton.classList.add(`swiper-button-prev-${index}`)
                    nextButton.classList.add(`swiper-button-next-${index}`)

                }

                swiper[index] = new Swiper(`.swiper-${index}`, {
                    speed: 750,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    navigation: {
                        nextEl: `.swiper-button-next-${index}`,
                        prevEl: `.swiper-button-prev-${index}`,
                    }
                });

            })

        }

    }


	init() {

		window.addEventListener('scroll', this.scrollHandler)
		
		this.toggleMenuButton.addEventListener('click', e => {

            if ( document.body.classList.contains('menu-is-open') ) {
				this.toggleMenuButton.setAttribute('aria-expanded', false);
                document.body.classList.remove('menu-is-open')
            } else {
				this.toggleMenuButton.setAttribute('aria-expanded', true);
                document.body.classList.add('menu-is-open')
            }

        })

        const nav = new MainNavigation()
        this.initSwiperSlideshows()

	}

}

const site = new OsloWorld();
site.init();
